import {PRODUCTS} from "../../Config/ApiUrl";
import {deleteAction, editAction} from "../../Helpers/TableAction";
import {createdFilter} from "../../Helpers/TableFIlter";
import {actionColumn, htmlColumn, nameColumn, objectColumn} from "../../Helpers/TableCommonColumn";
import DatatableHelperMixin from "../../Mixins/DatatableHelperMixin";
import {numberWithCurrencySymbol} from "../../Helpers/Helpers";
import {urlGenerator} from "../../Helpers/AxiosHelper";
import Vue from "vue";

export default {
    mixins: [DatatableHelperMixin],
    data() {
        return {
            options: {
                name: this.$allLabel('products'),
                url: PRODUCTS,
                responsive: true,
                columns: [
                    htmlColumn(
                        this.$t('name'),
                        'name',
                        (name, row) => `<a href="${urlGenerator(this.apiUrl.PRODUCTS)}/${row.slug}/edit">${name}</a>`
                    ),
                    objectColumn(this.$t('brand'), 'brand', v => v?.name),
                    htmlColumn(this.$t('categories'), 'categories', categories => {
                        return categories.map(category => `${category.name},<br/>`).join('')
                    }),
                    htmlColumn(
                        this.$t('purchase_price'),
                        'purchase_price',
                        price => numberWithCurrencySymbol(price)
                    ),
                    htmlColumn(
                        this.$t('sell_price'),
                        'sell_price',
                        sell_price => numberWithCurrencySymbol(sell_price)
                    ),
                    htmlColumn(
                        this.$t('total_discount_amount'),
                        'default_discount',
                        default_discount => numberWithCurrencySymbol(default_discount)
                    ),
                    htmlColumn(
                        this.$t('status'),
                        'status',
                        status => `<span class="badge badge-pill badge-${status.class}">${status.translated_name}</span>`
                    ),
                    actionColumn(),
                ],
                filters: [
                    createdFilter()
                ],
                actionType: "dropdown",
                actions: [
                    editAction(this.$can('update_categories'), PRODUCTS),
                    deleteAction(this.$can('delete_categories'), PRODUCTS),
                    {
                        title: Vue.prototype.$t('move_to_draft'),
                        key: "move_to_draft",
                        name: "move_to_draft",
                        url: urlGenerator(PRODUCTS),
                        icon: 'trash',
                        modifier: row => this.$can('move_product_to_draft') && row.status.name === 'status_published',
                    },
                    {
                        title: Vue.prototype.$t('publish'),
                        key: "publish",
                        name: "publish",
                        url: urlGenerator(PRODUCTS),
                        icon: 'trash',
                        modifier: row => this.$can('publish_product') && row.status.name === 'status_draft',
                    }
                ],
                rowLimit: 10,
                paginationType: "pagination"
            },
            isModalActive: false,
            selectedUrl: null,
            confirmationModalActive: false
        }
    },
    methods: {
        triggerActions(row, action, active) {
            this.product_slug = row.slug;
            if (action.key === 'edit') {
                this.isModalActive = true;
                this.selectedUrl = `${this.apiUrl.PRODUCTS}/${row.slug}`
            }else if (action.name === 'delete') {
                this.delete_url =  `/${this.apiUrl.PRODUCTS}/${row.slug}`
                this.confirmationModalActive = true;
            }else if (action.key === 'move_to_draft') {
                this.statusModal = true;
                this.statusMessage = this.$t('do_you_really_want_to_move_this_product_to_draft');
            }else if (action.key === 'publish') {
                this.statusModal = true;
                this.statusMessage = this.$t('do_you_really_want_to_publish_this_product');
            }
        }
    }
}